import {
  Badge,
  BankAccountResolver,
  CurrencyDisplay,
  SearchBar,
  SectionSubheader,
  SwitchAppButton,
  SwitchAppContentSwitcher,
  SwitchAppIconButton,
} from "../../../../../components";
import {
  HookFormCheckbox,
  HookFormSelect,
  SubmitButton,
  TextInput,
} from "../../../../../hook-form";
import { filterSupportedCountriesFromList } from "../../../../../utils";
import {
  ISingleTransferViewProps,
  TNewOrBeneficiaryRecipient,
} from "./SingleBankTransferForm";
import { countries, currencies } from "../../../../../constants";
import closeIconRed from "../../../../../assets/icons/close-circle-red.svg";
import { RecipientsTableHeader } from "./RecipientsTableHeader";
import { DevTool } from "@hookform/devtools";
import { BeneficiaryListItem } from "./BankBeneficiaryListItem";
import { BeneficiarySkeleton } from "./BeneficiarySkeleton";
import { TransferFeeAndRateDisplay } from "./TransferFeeAndRateDisplay";

export const View = (props: ISingleTransferViewProps) => {
  const {
    navigateToBatchList,
    isBatchEditMode,

    beneficiaries,
    isLoadingBeneficiaries,
    setSearchBeneficiaryText,
    newOrBeneficiaryView,
    setNewOrBeneficiaryView,
    selectBeneficiary,
    clearSelectedBeneficiary,

    isLoadingSupportedCountries,
    swAppSupportedCountries,
    isLoadingSupportedCurrencies,
    swAppSupportedCurrencies,
    isLoadingBankList,
    bankList,

    isBankAccountResolved,
    setBankAccountResolved,
    setResolvedBankAccountDetails,

    // fees & rates
    destinationCountryIsNotNigeria,

    formValues,
    // isDirty,
    control,
    errors,
    handleSubmit,
    register,
  } = props;

  const beneficiaryCountry = countries
    .find(
      (grp) =>
        grp.options.find((ctry) => ctry.value === formValues.country) !==
        undefined
    )
    ?.options.find((ctry) => ctry.value === formValues.country);

  // TODO: add a global context with supported countries and currencies
  // const currency = swAppSupportedCurrencies.find((cur) => cur.value === item.currency);
  const beneficiaryCurrency = currencies.find(
    (cur) => cur.value === formValues.currency
  );

  const targetCountryIsNigeria = !destinationCountryIsNotNigeria;
  // !!formValues.country && formValues.country.toUpperCase() === "NG";

  return (
    <form className="single-bank-transfer--form" onSubmit={handleSubmit}>
      <div className="flex-container justify-content--between align-items--center row">
        <div className="flex-box">
          <SectionSubheader
            title={
              isBatchEditMode ? "UPDATE BATCH ENTRY" : "NEW TRANSFER RECIPIENT"
            }
            // className="search-section--header"
          />
        </div>

        <div className="d-md-none">
          <SwitchAppButton
            kind="danger"
            onClick={navigateToBatchList}
            size="sm"
            className="flex-box mt-5"
          >
            Back To List
          </SwitchAppButton>
        </div>
      </div>

      <div className="flex-container flex-break--small">
        <div className="flex-box">
          <TextInput
            name="reference"
            label="Reference"
            infoIconText="Unique reference for this transfer"
            type="text"
            register={register}
            errors={errors}
          />
        </div>
        {/* <div className="flex-box mr-md-5">xxxxxxxxxxxx</div> */}
      </div>

      <div className="flex-container flex-break--small">
        <div className="flex-box mt-5">
          <SwitchAppContentSwitcher<TNewOrBeneficiaryRecipient>
            onChange={({ name }) => {
              setNewOrBeneficiaryView(name);
            }}
            options={[
              {
                key: "Saved Beneficiaries",
                value: "beneficiary",
              },
              {
                key: "New Transfer",
                value: "new",
              },
            ]}
            selectedValue={newOrBeneficiaryView}
          />
        </div>
      </div>

      {newOrBeneficiaryView === "new" ? null : (
        <div className="beneficiary-details--container mt-5">
          {formValues.beneficiary_id === null ? (
            <>
              <SearchBar
                name="search-beneficiaries"
                placeholder="Search beneficiaries..."
                onChange={(e: any) => setSearchBeneficiaryText(e.target.value)}
                onClear={() => setSearchBeneficiaryText("")}
                className="beneficiary-searchbar"
              />

              <div className="beneficiaries-list--container">
                <div className="cds--structured-list">
                  <RecipientsTableHeader />
                  <div className="mr-5 cds--structured-list-tbody cursor-pointer">
                    {!isLoadingBeneficiaries ? null : (
                      <>
                        <BeneficiarySkeleton />
                        <BeneficiarySkeleton />
                        <BeneficiarySkeleton />
                        <BeneficiarySkeleton />
                        <BeneficiarySkeleton />
                      </>
                    )}

                    {beneficiaries.map((benef, index) => (
                      <BeneficiaryListItem
                        beneficiary={benef}
                        selectBeneficiary={selectBeneficiary}
                        key={benef.id}
                      />
                    ))}
                  </div>
                </div>

                {isLoadingBeneficiaries || beneficiaries.length > 0 ? null : (
                  <div className="empty-transfers--list flex-container col justify-content--center align-items--center">
                    <div className="central--container flex-container col justify-content--center align-items--center">
                      <span className="pt-5">
                        {!setSearchBeneficiaryText
                          ? "No saved beneficiaries yet..."
                          : "No beneficiary was found for the search parameters..."}
                      </span>

                      <div className="pt-5">
                        <SwitchAppButton
                          kind="danger"
                          onClick={() => setNewOrBeneficiaryView("new")}
                          size="sm"
                          className="flex-box mt-5"
                        >
                          Transfer To New Recipient
                        </SwitchAppButton>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="selected-beneficiary-details">
              <div
                className="close-button--container"
                title="clear selected beneficiary"
              >
                <SwitchAppIconButton
                  size="sm"
                  kind="tertiary"
                  className="line-item--remove-button"
                  onClick={clearSelectedBeneficiary}
                >
                  <img
                    src={closeIconRed}
                    alt="close icon"
                    className="close-icon"
                  />
                </SwitchAppIconButton>
              </div>

              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">
                  Alias/Nickname:
                </span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues?.fullNameHelper}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">Country:</span>{" "}
                <strong className="font-ctm--extrabold">
                  {beneficiaryCountry?.text}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">Currency:</span>{" "}
                <strong className="font-ctm--extrabold">
                  {beneficiaryCurrency?.text}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">Bank:</span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues.bankNameHelper}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">
                  Account Number:
                </span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues.account_number}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">
                  Account Name:
                </span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues.accountNameHelper}
                </strong>
              </div>

              <div className="flex-container align-items--end bb-1">
                {isBankAccountResolved ? (
                  <strong className="text-danger font-ctm--extrabold mr-3">
                    ACCOUNT RESOLVED:
                  </strong>
                ) : null}
                <strong>
                  <BankAccountResolver
                    accountNumber={formValues.account_number}
                    bankCode={formValues.bank_code}
                    country={formValues.country}
                    currency={formValues.currency}
                    isBankAccountResolved={isBankAccountResolved}
                    setBankAccountResolved={setBankAccountResolved}
                    setResolvedBankAccountDetails={
                      setResolvedBankAccountDetails
                    }
                  />
                </strong>
              </div>
            </div>
          )}

          <TextInput
            name="amount"
            label="Amount"
            infoIconText="Amount to transfer"
            type="number"
            register={register}
            errors={errors}
          />

          {/* Display transfer fee & conversion rate */}
          {formValues.amount <= 0 ? null : (
            <div className="fee-and-rate--container flex-container pt-5">
              <TransferFeeAndRateDisplay {...props} />
            </div>
          )}
        </div>
      )}

      {newOrBeneficiaryView === "beneficiary" ? null : (
        <div className="">
          {/* Causes pushing new page to prompt if form is dirty */}
          {/* {!isDirty ? null : 
          <PromptOnDirtyFormClose
            when={globalStore.isLoadingMainScreen}
            message={
              () => `Are you sure you want to leave this page?`
              // location => `Are you sure you want to go to ${location.pathname}`
            }
          />} */}

          <div className="flex-container flex-break--small">
            <div className="flex-box mr-md-5">
              <HookFormCheckbox
                name="save_as_beneficiary"
                label="Save As Beneficiary"
                checked={formValues.save_as_beneficiary || false}
                infoIconText="Save this recipient in your beneficiaries list"
                register={register}
                errors={errors}
              />
            </div>
          </div>

          {!formValues.save_as_beneficiary ? null : (
            <div className="flex-container flex-break--small">
              <div className="flex-box">
                {targetCountryIsNigeria ? (
                  <TextInput
                    name="full_name"
                    label="Beneficiary Alias/Nickname (Optional)"
                    infoIconText="A name easier for you to identify the beneficiary (Optional)"
                    type="text"
                    register={register}
                    errors={errors}
                  />
                ) : (
                  <TextInput
                    name="account_name"
                    label="Beneficiary/Account Name"
                    infoIconText="The full name of the account beneficiary"
                    type="text"
                    register={register}
                    errors={errors}
                  />
                )}
              </div>
            </div>
          )}

          <div className="flex-container flex-break--small">
            <div className="flex-box">
              <HookFormSelect
                name="country"
                label="Country (Destination Bank)"
                infoIconText="Country where destination bank account is located"
                showSkeleton={isLoadingSupportedCountries}
                selectItems={[]}
                selectGroupedItems={filterSupportedCountriesFromList(
                  swAppSupportedCountries
                )}
                register={register}
                errors={errors}
              />
            </div>
            <div className="flex-box  ml-md-5">
              {/* {targetCountryIsAbroad ? null : (
                <TextInput
                  name="routing_number"
                  label="Routing Number"
                  infoIconText={
                    <>
                      Routing number is used for <br />
                      international bank transfers
                    </>
                  }
                  type="text"
                  register={register}
                  errors={errors}
                />
              )} */}
            </div>
          </div>

          {targetCountryIsNigeria ? null : (
            <>
              {/* Sort Code & Swift code */}
              <div className="flex-container flex-break--small">
                <div className="flex-box">
                  <TextInput
                    name="sort_code"
                    label="Sort code/Routing number"
                    infoIconText={
                      <>Sort Code/Routing Number for the beneficiary bank</>
                    }
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className="flex-box  ml-md-5">
                  <TextInput
                    name="swift_code"
                    label="Swift code"
                    infoIconText={<>Swift code for the beneficiary bank</>}
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
              </div>

              {/* International Beneficiary Details */}
              {/* Email & PhoneNumber */}
              <div className="flex-container flex-break--small">
                <div className="flex-box">
                  <TextInput
                    name="email"
                    label="Beneficiary Email"
                    infoIconText={
                      <>
                        Email of the beneficiary. We might use this to contact
                        them concerning this transfer if any issues are
                        encountered.
                      </>
                    }
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className="flex-box  ml-md-5">
                  <TextInput
                    name="phone_number"
                    label="Beneficiary Phone Number"
                    infoIconText={
                      <>
                        International phone number of the beneficiary in the
                        destination country.
                      </>
                    }
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
              </div>

              {/* StreetNumber & StreetName */}
              <div className="flex-container flex-break--small">
                <div className="flex-box">
                  <TextInput
                    name="street_number"
                    label="Beneficiary Street Number"
                    infoIconText={
                      <>
                        Street Number of beneificiary in the destination
                        country.
                      </>
                    }
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className="flex-box  ml-md-5">
                  <TextInput
                    name="street_name"
                    label="StreetName"
                    infoIconText={
                      <>Beneficiary Street Name in the destination country.</>
                    }
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
              </div>

              {/* City & PostalCode */}
              <div className="flex-container flex-break--small">
                <div className="flex-box">
                  <TextInput
                    name="city"
                    label="City"
                    infoIconText={<>Beneficiary City.</>}
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className="flex-box  ml-md-5">
                  <TextInput
                    name="postal_code"
                    label="Postal Code"
                    infoIconText={<>Beneficiary Postal Code.</>}
                    type="text"
                    register={register}
                    errors={errors}
                  />
                </div>
              </div>
            </>
          )}

          <div className="flex-container flex-break--small">
            {/* NOTE: disabled b/c this will require currency conversions */}

            <div className="flex-box mr-md-5">
              <HookFormSelect
                name="currency"
                label="Currency (Destination Acc.)"
                infoIconText="The currency of the bank account you want to transfer to eg NGN"
                showSkeleton={
                  !!formValues.country && isLoadingSupportedCurrencies
                }
                selectItems={swAppSupportedCurrencies.map((cur) => ({
                  text: `${cur.currency_name} (${cur.currency_symbol})`,
                  value: cur.currency,
                }))}
                register={register}
                errors={errors}
                // disabled={!formValues.xxxxxxxx}
              />
            </div>
            <div className="flex-box">
              {targetCountryIsNigeria ? (
                <HookFormSelect
                  name="bank_code"
                  label="Bank"
                  infoIconText="The withdrawal bank"
                  showSkeleton={isLoadingBankList}
                  selectItems={bankList.map((bnk) => ({
                    text: bnk.bank_name,
                    value: bnk.bank_code,
                  }))}
                  register={register}
                  errors={errors}
                  disabled={!formValues.country || !formValues.currency}
                />
              ) : (
                <TextInput
                  name="bank_name"
                  label="Bank Name"
                  infoIconText={<>Beneficiary Bank Name.</>}
                  type="text"
                  register={register}
                  errors={errors}
                />
              )}
            </div>
          </div>

          <div className="flex-container flex-break--small">
            <div className="flex-box mr-md-5">
              <TextInput
                name="account_number"
                label="Account Number/IBAN"
                infoIconText="The recipient's account number"
                type="text"
                register={register}
                errors={errors}
              />

              <div className="flex-container">
                {destinationCountryIsNotNigeria ? null : (
                  <BankAccountResolver
                    accountNumber={formValues.account_number}
                    bankCode={formValues.bank_code}
                    country={formValues.country}
                    currency={formValues.currency}
                    isBankAccountResolved={isBankAccountResolved}
                    setBankAccountResolved={setBankAccountResolved}
                    setResolvedBankAccountDetails={
                      setResolvedBankAccountDetails
                    }
                  />
                )}
              </div>
            </div>

            <div className="flex-box">
              <TextInput
                name="amount"
                label="Amount"
                infoIconText="Amount to transfer"
                type="number"
                register={register}
                errors={errors}
              />

              {/* Display transfer fee & conversion rate */}
              {formValues.amount <= 0 ? null : (
                <div className="fee-and-rate--container flex-container pt-5">
                  <TransferFeeAndRateDisplay {...props} />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <TextInput
        name="description"
        label="Short Description (Optional)"
        infoIconText="A description of this transfer (Optional)"
        type="text"
        register={register}
        errors={errors}
      />

      <SubmitButton
        kind="success"
        size="sm"
        className="mt-5"
        showChildrenWithLoadingIcon
        disabled={targetCountryIsNigeria && !isBankAccountResolved}
      >
        {isBatchEditMode ? "Save Changes" : "+ Add Transfer To List"}
      </SubmitButton>

      {/* set up the dev tool */}
      <DevTool control={control} />
    </form>
  );
};
